type AnyObject = { [key: string]: any };

export const deepEqualArrays = (arr1: AnyObject[], arr2: AnyObject[]): boolean => {
  if (arr1.length !== arr2.length) return false;

  arr1 = arr1.sort();
  arr2 = arr2.sort();

  for (let i = 0; i < arr1.length; i++) {
    if (JSON.stringify(arr1[i]) !== JSON.stringify(arr2[i])) {
      return false;
    }
  }

  return true;
};
